// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"2255287c","498":"07a7b68a","513":"c826d3ff","787":"d1d4a2c2"}[chunkId] + ".chunk.js";
};